import { CustomizedTypography } from '@components/Customized';
import { styled } from '@material-ui/core';
import { ReactNode } from 'react';

interface Props {
  children?: ReactNode;
}
export default function BubbleContent({ children }: Props) {
  return (
    <Wrapper>
      <CustomizedTypography variant="body2" color="textPrimary">
        {children}
      </CustomizedTypography>
    </Wrapper>
  );
}

const Wrapper = styled('div')({
  padding: '16px 16px 0px 16px',
  '& p': {
    wordBreak: 'break-all'
  },
  '& + &': {
    paddingTop: 20
  }
});
